export function schedulerDisplayName(schedulerName: string) {
  switch (schedulerName?.toLowerCase()) {
    case "sge":
      return "SGE";
    case "slurm":
      return "Slurm";
    default:
      return schedulerName;
  }
}
